import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-mist bg-grid-light py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-268" data-mp="3fznsli0714zs">
      <div className="mx-auto max-w-6xl px-4" data-id="element-269" data-mp="3b0koq0vy94te">
        <p className="text-center font-mono text-[11px] font-bold uppercase tracking-[.2em] text-steel" data-id="element-270" data-mp="3azt39iw2gngu">Lo que dicen los que ya lo tienen</p>
        <h2 id="reviews-title" className="mt-3 text-center text-3xl font-extrabold uppercase text-ink sm:text-4xl" data-id="element-271" data-mp="36wmp7p2pprzt">
          Automatización Industrial con contexto argentino
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-272" data-mp="2x2w3grxyzvnt">
          {reviews.map(([initials, name, role, quote, color], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-ivory flex min-h-[255px] flex-col rounded-md border border-line border-t-2 border-t-steel p-6 text-ink shadow-card" data-id="element-273" data-mp="v96n88kr2bno" data-mpi={index}>
              <div className="flex text-gold" data-id="element-274" data-mp="79lfrj0zf39x">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" data-id="element-275" data-mp="c8y09x4dry9c" />)}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-276" data-mp="zyscqdksfkt2">“{quote}”</blockquote>
              <div className="mt-5 flex items-center gap-3 border-t border-line pt-4" data-id="element-277" data-mp="q6mmb8a6pbfz">
                <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-sm font-mono text-sm font-bold text-white ${color}`} data-id="element-278" data-mp="q4sbwnwjh1q5">
                  {initials}
                </span>
                <span data-id="element-279" data-mp="1ith3nwbpfup8">
                  <b className="block text-sm text-ink" data-id="element-280" data-mp="1nlqs17x68mpe">{name}</b>
                  <small className="text-xs text-muted" data-id="element-281" data-mp="1no3g82tivtaw">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}